import { observer } from 'mobx-react';

import { FC, PropsWithChildren, useEffect } from 'react';
import { anonymousStackKey, dashboardKey, dashboardStackKey, privateKey, publicKey, reckoningResultKey, redirectLoginRegisterKey, sessionStackKey, tabsKey } from '../../constants/routeKeys';
import { concatPath } from '../../utils/links/concatPath';
import { loginKey, onlyPublicKeys } from '../../constants/routeKeys';
import { router, useGlobalSearchParams, usePathname, useSegments } from 'expo-router';
import { useStores } from '../../hooks/useStores';



export const RedirectApp: FC<PropsWithChildren> = observer(({children}) => {
  const {user} = useStores();

  const hasUser = !!user?.user;
  const isAnon = user?.anonymous;
  const pathname = usePathname();
  const segments = useSegments();
  const params = useGlobalSearchParams();


  const authenticatedUser = hasUser && !isAnon;


  const sharedRoutesAnonPrivate = [sessionStackKey, reckoningResultKey];

  useEffect(() => {
    if (pathname === '/') {
      // ABSOLUTE (-1), like every other branch below. These two were the only ones built
      // relative (order 0 => a './' prefix), and "/" is precisely where that cannot work:
      // nothing matches the root path, so the app is sitting on +not-found when this
      // runs, and the relative href resolved against THAT -- producing nonsense like
      // /(private)/(public)/(Tabs)/login, which does not exist either. The redirect
      // therefore failed and the user was left on "Oops, this page does not exist" at
      // launch, with no way out but the button.
      if (authenticatedUser) {
        // Redirect to private page
        router.replace(concatPath([privateKey, dashboardStackKey,dashboardKey], -1));
      } else {
        // Redirect to public page
        router.replace(concatPath([publicKey, tabsKey, loginKey], -1));
      }
    } else if(authenticatedUser && onlyPublicKeys.some(val => val === pathname.substring(1))) {
      router.replace(concatPath([privateKey, dashboardStackKey,dashboardKey], -1));
    } else if(pathname.substring(1) === redirectLoginRegisterKey) {
      router.replace(concatPath([publicKey, tabsKey, loginKey], -1));
    } else if(authenticatedUser && !isAnon && segments.includes(anonymousStackKey) && segments.some(s => sharedRoutesAnonPrivate.includes(s))) {
      const modSegments = segments.map(s => s === anonymousStackKey ? privateKey : s);
      console.log('modSegments',modSegments);
      router.replace({
        pathname:concatPath(modSegments, -1) as string,
        params: params
      });
    }
  }
  , [pathname, router, authenticatedUser]);




  return (
    <>
      {children}
    </>
  );


});
